<script>
	import { isPortraitScreen, pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _sun;
	let portrait;
	let speed = 1;

	let animation = (value) => {
		animateElement(value, _sun, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset / 5;

			_sun.style.transform = `translateX(${scrolledStartSectionPercentage * 0.02 * speed}em) translateY(${scrolledStartSectionPercentage * 0.05 * speed}em)`;
		});
	};


	let prepareScene = () => {
		if (!_sun) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
			speed = state ? 2 : 1;
		});

		_sun.style.pointerEvents = 'auto';
		_sun.addEventListener('click', () => {

			console.log('Sun click. Requesting devicemotion permission.');

			if (window.DeviceMotionEvent) {
				if (typeof window.DeviceMotionEvent.requestPermission === 'function') {
					window.DeviceMotionEvent.requestPermission()
						.then(response => {
							if (response === 'granted') {
								window.addEventListener('devicemotion', (event) => { alert('DeviceMotionChange', event); }, false);
							}
						})
						.catch(window.alert);
				}
			}
		});
	};

	prepareScene();
</script>

<style>
	#sun {
		position: absolute;
	}

	svg {
		position: absolute;
		width: 8em;
		height: auto;
		right: 16em;
		bottom: 39em;
		overflow: visible;
		z-index: -1;
	}

	svg.portrait {
		width: 2.6em;
		right: 2em;
		bottom: 14em;
	}
</style>

<svg class:portrait fill="none" height="127" viewBox="0 0 127 127" width="127" xmlns="http://www.w3.org/2000/svg">
	<g id="sun" bind:this={_sun}>
		<path d="m126.839 63.1166c0 34.8302-28.2559 63.1164-63.0491 63.1164-34.7931 0-63.049421-28.2862-63.049421-63.1164.210867-34.8302 28.467121-63.1166 63.260321-63.1166s62.8382 28.2864 62.8382 63.1166z" fill="#ebc851"/>
	</g>
</svg>
